import * as CONST from '../ActionTypes';

const initialState = {
  custoemrList: [],
};

function custoemr(state = initialState, action) {
  switch (action.type) {
    // -----------------
    // 決済履歴一覧取得
    // -----------------
    case CONST.GET_CUSTOMER_LIST_SUCCESS:
      return Object.assign(
        {},
        state,
        {
          custoemrList: action.payload,
        },
      );
    case CONST.GET_CUSTOMER_LIST_FAILURE:
      return Object.assign(
        {},
        state,
        {
          custoemrList: [],
        },
      );
    default:
      return state;
  }
}

export default custoemr;
